<template>
  <div class="success-modal">
    <div class="success-icon">
      <i class="fal fa-check-circle"></i>
    </div>
    <div class="success-title">{{ $t("codTransferWaiting.success") }}</div>

    <div class="info-row">
      <span class="info-label">{{ $t("codTransferWaiting.shop") }}</span>
      <span class="info-value strong">{{ item.name }}</span>
    </div>
    <div class="info-row">
      <span class="info-label">{{ $t("codTransferWaiting.bill_count") }}</span>
      <span class="info-value strong amount">{{ formatCurrency(item.bill_count) }} {{ $t("common.ກີບ") }}</span>
    </div>

    <button class="btn-ok" @click="onOk">{{ $t("codTransferWaiting.ok") }}</button>
  </div>
</template>

<script>
export default {
  name: 'SuccessConfirmDialog',
  props: {
    item: { type: Object, required: true },
  },
  methods: {
    formatCurrency(v) { return (Number(v) || 0).toLocaleString('en-US'); },
    onOk() { this.$emit('close'); },
  },
};
</script>

<style lang="scss" scoped>
.success-modal {
  padding: 8px 16px 12px;
  text-align: center;
  width: 320px;
  max-width: 100%;
}
.success-icon {
  font-size: 56px;
  color: #22a06b;
  margin: 8px 0 4px;
  line-height: 1;
}
.success-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c2f36;
  margin-bottom: 14px;
}
.info-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 12px;
  background: #f5f7fb;
  border-radius: 6px;
  margin-bottom: 6px;
  font-size: 13px;
  &:last-of-type { margin-bottom: 12px; }
}
.info-label { color: #8b8f99; }
.info-value.strong { font-weight: 600; color: #2c2f36; }
.info-value.amount { font-size: 14px; }
.btn-ok {
  width: 100%;
  height: 42px;
  border: none;
  border-radius: 8px;
  background: #195BFF;
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  font-family: $font;
  cursor: pointer;
  &:hover { background: #1450e6; }
}
</style>
